import useAppMutation from 'hooks/useAppMutation';
import API from 'services/API';
import { useQueryClient } from '@tanstack/react-query';
import { AUTOMATED_REVIEW_LOGS_BASE_QUERY_KEY } from 'components/domain/review/automatedReviewLogs/automatedReviewLogsQuery';
import { useTranslation } from 'react-i18next';
import useNotify from 'hooks/useNotify';
import { AutomatedReviewLog } from 'models/automation/Reviews';

const useActionRetryAutomatedReviewLog = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { notifyError, notifySuccess } = useNotify();

  const { mutateAsync, isLoading } = useAppMutation({
    mutationFn: ({
      automatedReviewLog,
    }: {
      automatedReviewLog: AutomatedReviewLog;
    }) => {
      return API.post(
        `/api/internal/scheduled-hosts-reviews/${automatedReviewLog.uid}/post`,
      );
    },
    onSuccess: () => {
      notifySuccess(
        t(
          'pageAutomations.reviews.automatedReviewLogs.actions.retry.retrySuccess',
        ),
      );
    },
    onError: () => {
      notifyError(
        t(
          'pageAutomations.reviews.automatedReviewLogs.actions.retry.retryError',
        ),
      );
    },
    onSettled: () => {
      queryClient.invalidateQueries([AUTOMATED_REVIEW_LOGS_BASE_QUERY_KEY]);
    },
  });

  return {
    retryAutomatedReviewLog: mutateAsync,
    isRetrying: isLoading,
  };
};

export default useActionRetryAutomatedReviewLog;
